const hasControlOrBackslash = (value) => [...value].some((char) => char === "\\" || char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127);
export function safeReturnTarget(value) {
    if (typeof value !== "string" ||
        value.length > 4096 ||
        !value.startsWith("/") ||
        value.startsWith("//") ||
        hasControlOrBackslash(value))
        return null;
    try {
        const url = new URL(value, "https://hub.invalid");
        if (url.origin !== "https://hub.invalid")
            return null;
        let path = url.pathname;
        for (let i = 0; i < 4; i++) {
            if (hasControlOrBackslash(path) ||
                /%2f|%5c/i.test(path) ||
                path.split("/").some((part) => part === "." || part === ".."))
                return null;
            const decoded = decodeURIComponent(path);
            if (decoded === path)
                break;
            path = decoded;
            if (i === 3)
                return null;
        }
        const route = url.pathname;
        if (!(route === "/" ||
            /^\/(crm|projekte|finanzen|marketing|lernen|befragungen|wissen|bem|berichte|administration|dokumentation|dateiexplorer|hilfe|lernportal|auswertungen)(\/|$)/.test(route) ||
            /^\/einstellungen\/(profil|e-mail)$/.test(route)))
            return null;
        if (path === "/lernportal/anmelden")
            return null;
        return `${url.pathname}${url.search}${url.hash}`;
    }
    catch {
        return null;
    }
}
export function returnHome(session) {
    return session.user.role === "learner" ? "/lernportal" : "/";
}
export function permittedReturnTarget(value, session) {
    const target = safeReturnTarget(value);
    if (!target)
        return returnHome(session);
    const path = new URL(target, "https://hub.invalid").pathname;
    if (session.user.role === "learner")
        return path === "/lernportal" ||
            path === "/einstellungen/profil" ||
            path.startsWith("/auswertungen/")
            ? target
            : "/lernportal";
    const feature = [
        ["/crm", "crm"],
        ["/einstellungen/e-mail", "crm"],
        ["/projekte", "projects"],
        ["/finanzen", "finance"],
        ["/marketing", "marketing"],
        ["/lernen", "learning"],
        ["/befragungen", "surveys"],
        ["/wissen", "knowledge"],
        ["/bem", "bem"],
        ["/berichte", "reports"],
        ["/administration", "admin"],
        ["/dokumentation", "documentation"],
    ].find(([prefix]) => path === prefix || path.startsWith(`${prefix}/`))?.[1];
    return feature && session.features[feature] !== true ? returnHome(session) : target;
}
//# sourceMappingURL=auth-return-target.js.map